import React, { useState } from 'react';
import { Link } from 'react-router-dom';
// import { FaShoppingCart } from 'react-icons/fa';
import katalogImage1 from '../assets/KATALOG-1.jpg';
import katalogImage2 from '../assets/KATALOG-2.jpg';
import katalogImage3 from '../assets/KATALOG-3.jpg';
import katalogImage4 from '../assets/SIZECHART.jpg';
import model1 from '../assets/model1.JPG';
import model2 from '../assets/model2.JPG';
import model3 from '../assets/model3.JPG';
import model4 from '../assets/model4.JPG';
import shopee from '../assets/shopee.png';
import './ProductDetail.css';

const ProductDetail = () => {
    const [selectedImage, setSelectedImage] = useState(katalogImage1);
    const [selectedColor, setSelectedColor] = useState('black');
    const [selectedSize, setSelectedSize] = useState('REGULAR');
    const [quantity, setQuantity] = useState(1);

    const handleThumbnailClick = (image) => {
        setSelectedImage(image);
    };

    const handleColorClick = (color) => {
        setSelectedColor(color);
    };

    const handleSizeClick = (size) => {
        setSelectedSize(size);
    };

    const handleQuantityChange = (change) => {
        setQuantity((prevQuantity) => Math.max(1, prevQuantity + change));
    };

    const productTitle = "Oversized Noir Shirt";

    const handleBuyNow = () => {
        const message = `Halo men, saya mau order ${quantity} ${productTitle} ukuran ${selectedSize}`;
        const phoneNumber = '+6285179583850';
        const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
        window.open(whatsappUrl, '_blank');
    };

    return (
        <div className="product-detail-container">
            {/* Combined Image and Product Details Section */}
            <div className="grid-section">
                <div className="image-section">
                    <img className="main-image" src={selectedImage} alt="Product" />
                    <div className="thumbnail-container">
                        <img className={`thumbnail ${selectedImage === katalogImage1 ? 'selected' : ''}`} src={katalogImage1} alt="Thumbnail 1" onClick={() => handleThumbnailClick(katalogImage1)} />
                        <img className={`thumbnail ${selectedImage === katalogImage2 ? 'selected' : ''}`} src={katalogImage2} alt="Thumbnail 2" onClick={() => handleThumbnailClick(katalogImage2)} />
                        <img className={`thumbnail ${selectedImage === katalogImage3 ? 'selected' : ''}`} src={katalogImage3} alt="Thumbnail 3" onClick={() => handleThumbnailClick(katalogImage3)} />
                        <img className={`thumbnail ${selectedImage === katalogImage4 ? 'selected' : ''}`} src={katalogImage4} alt="Thumbnail 4" onClick={() => handleThumbnailClick(katalogImage4)} />
                    </div>
                </div>

                <div className="product-details">
                    <span className="new-collection-label">NEW COLLECTION</span>
                    <h1 className="product-title">{productTitle}</h1>
                    <p className="product-description">Stylish and comfortable black baby corduroy shirt, essential for any man's wardrobe. Perfect for versatile styling and comfort.</p>
                    <p className="product-price">Rp. 170.000</p>

                    <p className="product-size">PILIH WARNA</p>
                    <div className="color-selector">
                        <div className={`color-option ${selectedColor === 'black' ? 'selected' : ''}`} style={{ backgroundColor: '#000' }} onClick={() => handleColorClick('black')} />
                    </div>

                    <p className="product-size">PILIH UKURAN</p>
                    <div className="size-selector">
                        <button className={`size-button ${selectedSize === 'REGULAR' ? 'selected' : ''}`} onClick={() => handleSizeClick('REGULAR')}>REGULAR</button>
                        <button className={`size-button ${selectedSize === 'LARGE' ? 'selected' : ''}`} onClick={() => handleSizeClick('LARGE')}>LARGE</button>
                    </div>

                    <p className="product-size">QUANTITY</p>
                    <div className="quantity-selector">
                        <button className="quantity-button" onClick={() => handleQuantityChange(-1)}>-</button>
                        <input type="number" className="quantity-input" value={quantity} onChange={(e) => setQuantity(Math.max(1, parseInt(e.target.value)))} />
                        <button className="quantity-button" onClick={() => handleQuantityChange(1)}>+</button>
                    </div>

                    <div className="button-group">
                        <button className="buy-button" onClick={handleBuyNow}>Direct Order</button>
                        {/* <a href="/checkout">
                            <button className="buy-button">Go to Checkout</button>
                        </a> */}
                        <Link to="https://id.shp.ee/HcZtNCH" target="_blank" rel="noopener noreferrer">
                            <button className="cart-icon-button">
                                {/* <FaShoppingCart size={20} /> */}
                                <img src={shopee} alt='shopee logo' style={{ width: '20px', height: '20px' }} />
                            </button>
                        </Link>
                        <span style={{ fontSize: '10px', color: '#808080' }}>
                            *Jika checkout di Shopee, banyak diskon dan promo menarik!
                        </span>
                    </div>
                </div>
            </div>

            {/* Photo Gallery Section */}
            <div className="gallery-section">
                <h2>Gallery</h2>
                <div className="gallery-grid">
                    <img src={model1} alt="Gallery 1" />
                    <img src={model2} alt="Gallery 2" />
                    <img src={model3} alt="Gallery 3" />
                    <img src={model4} alt="Gallery 4" />
                </div>
            </div>
        </div>
    );
};

export default ProductDetail;
